import indexedDBService from '~/services/indexedDBService';

/**
 * Redux middleware to auto-save POS state to IndexedDB
 * Lưu state mỗi khi có thay đổi
 */
const offlineInvoiceMiddleware = store => next => action => {
    const result = next(action);

    // Chỉ save khi có action liên quan đến POS
    const posActions = [
        'pos/addTab',
        'pos/removeTab',
        'pos/setActiveTab',
        'pos/setCustomer',
        'pos/addItem',
        'pos/updateItemQuantity',
        'pos/removeItem',
        'pos/setDiscount',
        'pos/setPaid',
        'pos/setPaymentMethod',
        'pos/setQrCodeUrl',
    ];

    if (posActions.some(type => action.type === type)) {
        const state = store.getState();
        const posState = state.pos;

        // Debounce save - chờ 500ms sau action cuối
        if (window.offlineInvoiceSaveTimeout) {
            clearTimeout(window.offlineInvoiceSaveTimeout);
        }

        window.offlineInvoiceSaveTimeout = setTimeout(() => {
            indexedDBService.saveOfflineInvoice({
                tabs: posState.tabs,
                activeTab: posState.activeTab,
                nextTabId: posState.nextTabId,
            }).catch(err => {
                console.error('Failed to save offline invoice:', err);
            });
        }, 500);
    }

    // Clear offline invoice khi clearTab
    if (action.type === 'pos/clearTab') {
        const state = store.getState();
        const posState = state.pos;

        // Nếu tất cả tabs đều empty thì xóa offline invoice
        const hasData = posState.tabs.some(tab =>
            tab.items.length > 0 ||
            tab.customer !== null ||
            tab.discount > 0 ||
            tab.paid > 0
        );

        if (!hasData) {
            indexedDBService.deleteOfflineInvoice().catch(err => {
                console.error('Failed to delete offline invoice:', err);
            });
        }
    }

    return result;
};

export default offlineInvoiceMiddleware;
